import EventEmitter from "events";
import { PodcastEvent } from "../constants";
import { PodcastEpisode } from "./PodcastEpisode";

interface PodcastSeasonProps {
    element: HTMLElement;
}

export class PodcastSeason extends EventEmitter {
    private element: HTMLElement;
    private episodes: PodcastEpisode[] = [];
    private _selectedEpisode?: PodcastEpisode;

    constructor({ element }: PodcastSeasonProps) {
        super();
        this.element = element;
        this.init();
    }

    init(): void {
        const episodeElements = Array.from(this.element.querySelectorAll('.cwf-podcast-episode'));
        this.episodes = episodeElements.map((element: HTMLElement) => new PodcastEpisode({ element }));
        this.episodes.forEach((episode: PodcastEpisode) => episode.addListener(PodcastEvent.SELECT_EPISODE, this.onSelectEpisode.bind(this)));
    }

    onSelectEpisode(episode?: PodcastEpisode): void {
        this.episodes.forEach((episode: PodcastEpisode) => episode.deselect());

        if (episode) {
            episode.select();
        }

        this._selectedEpisode = episode;
        this.refreshUI();

        if (this._selectedEpisode) {
            // Do this first so we scroll to the right place
            this.emit(PodcastEvent.SELECT_SEASON, this);

            setTimeout(() => {
                const headerHeight = document.querySelector(".header")?.clientHeight || 0;
                const top = this.element.getBoundingClientRect().top + window.scrollY - headerHeight;
                window.scrollTo({ top, behavior: "smooth" });
            }, 50);
        }
    }

    refreshUI(): void {
        const func = !!this._selectedEpisode ? "add" : "remove";
        this.element.classList[func]("episode-selected");
    }

    close(): void {
        if (this._selectedEpisode) {
            this._selectedEpisode.deselect();
        }

        this._selectedEpisode = undefined;
        this.refreshUI();
    }

    get selectedEpisode(): PodcastEpisode | undefined {
        return this._selectedEpisode;
    }
}